import { render, staticRenderFns } from "./BtnStatusInternoLeilao.vue?vue&type=template&id=0513a533"
import script from "./BtnStatusInternoLeilao.vue?vue&type=script&lang=js"
export * from "./BtnStatusInternoLeilao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports